import { useEffect } from 'react';

const useWakeupDetection = func => {
  useEffect(() => {
    const workerCode = `
      let lastTime = performance.now();
      setInterval(() => {
        const currentTime = performance.now();
        if (currentTime - lastTime > 3000) { // Detect sleep
          postMessage('wakeup');
        }
        lastTime = currentTime;
      }, 1000);
    `;

    const blob = new Blob([workerCode], { type: 'application/javascript' });
    const worker = new Worker(URL.createObjectURL(blob));

    worker.onmessage = ev => {
      console.log('evvvv', ev);
      if (ev.data === 'wakeup') {
        console.log('System woke up from sleep');
        // Perform wakeup actions here
        func();
      }
    };

    return () => {
      worker.terminate();
    };
  }, []);

  return null;
};

export default useWakeupDetection;
